import { Injectable } from '@angular/core';
import { EmopTableProClass } from '../../class/EmopTableProClass/EmopTableProClass';
import { EmopPublicWorkflowCreateApiService } from './emop-public-workflow-create-api.service';

@Injectable({
  providedIn: 'root'
})
export class EmopPublicWorkflowCreateService {
  /**
   * 流程模板列表
   */
  workflowTemplateList = [];
  /**
   * 当前选中的流程模板列表
   */
  currentWorkflowTemplate = '';
  /**
   * 流程分配
   */
  processAssignment;
  /**
   * 指派人员列表
   */
  appointeeList = [];
  /**
   * 审批对象表格数据
   */
  approvalTable = new EmopTableProClass({
    header: [],
    data: [],
    mode: 'normal',
    pageInfo: {
      hideOnSinglePage: true
    },
    loading: false
  });
  /**
   * 自定义参数
   */
  customParams = {
    multiple: true,
    tenant: '',
    batchId: '',
    allowDeleteDefault: false,
  };
  constructor(
    private EmopPublicWorkflowCreateApiService: EmopPublicWorkflowCreateApiService
  ) { }

  /**
   * 清除数据
   */
  clearData() {
    this.workflowTemplateList = [];
    this.currentWorkflowTemplate = '';
    this.appointeeList = [];
  }
  /**
   * 流程模板修改回调
   */
  templateChange(value: string) {
    const that = this;
    this.appointeeList = [];
    this.EmopPublicWorkflowCreateApiService.taskDefinitions(value).subscribe((res) => {
      this.EmopPublicWorkflowCreateApiService.initProcessAssignment(value, this.customParams.tenant, this.customParams.batchId).subscribe((rs) => {
        this.appointeeList = res.data;
        this.processAssignment = rs.data;
        if (rs.data.taskAssignments.length) {
          rs.data.taskAssignments.forEach(item => {
            item.candidates[0].assignees.forEach(p => {
              p.allowDelete = that.customParams.allowDeleteDefault;
            });
            this.appointeeList.find(p => p.id === item.taskDefinitionKey).currentUser = item.candidates[0].assignees;
          });
        } else {
          this.appointeeList = null;
        }
      });
    });
  }
}
